import { render, staticRenderFns } from "./ContractPaymentMessage.vue?vue&type=template&id=4543b4fe&"
import script from "./ContractPaymentMessage.vue?vue&type=script&lang=ts&"
export * from "./ContractPaymentMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports